<template>
  <v-dialog :value="value" persistent max-width="800px">
    <div class="modal-container">
      <div class="d-flex w-full justify-end">
        <v-btn icon @click="$emit('input', false)" class="-mt-12 -mr-12">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>
      <img loading="lazy" src="https://storage.googleapis.com/keybe/files/bluebird/billing/credit-card.svg"
           alt="credit card" class="mb-4">
      <img src="https://storage.googleapis.com/keybe/files/bluebird/billing/success.svg" alt="success" class="mb-8">
      <div class="keybe-input focused flex flex-row justify-center align-center mb-4">
        <v-icon color="white">mdi-currency-usd</v-icon>
        <h5>{{ total }} USD</h5>
      </div>
      <strong>{{ $t('rechargeValidate') }}</strong>
      <span>{{ $t('keybeMessage') }}</span>
      <div class="d-flex flex-row justify-space-around align-center flex-wrap mt-6">
        <v-btn
            large
            width="150"
            elevation="0"
            dark
            color="#0FAEF6"
            rounded
            @click="$emit('allow-transaction', true)"
            class="mx-2">{{ $t('balancePay') }}
        </v-btn>
        <v-btn
            large
            width="150"
            elevation="0"
            dark
            color="#A9A9A9"
            rounded
            @click="$emit('input', false)"
            class="mx-2">{{ $t('cancel') }}
        </v-btn>
      </div>
    </div>
  </v-dialog>
</template>

<script>
export default {
  name: 'PaymentValidate',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    total: {
      type: Number
    }
  }
}
</script>

<style scoped>
.modal-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #FFFFFF;
  padding: 4rem
}
</style>
